import { tv } from "../../variants/tv.js";
const expandableInputVariants = tv({
    slots: {
        wrapperSlot: [
            'bg-primary-1 relative flex w-full flex-none flex-col items-center gap-2 rounded-3xl transition-colors duration-200',
            'py-3 pl-5 pr-3',
            'border',
            'focus-within:outline-none focus-within:ring-0'
        ],
        contentSlot: [
            'relative flex w-full flex-none items-center gap-2'
        ],
        textareaSlot: 'text-primary-10 text-body2 @md:text-body1 flex w-full resize-none items-center border-0 bg-transparent focus:outline-none focus:ring-0',
        voiceButtonSlot: 'text-icon-16 @md:w-6 @md:h-6 @md:text-icon-18 h-5 w-5',
        footerSlot: 'flex w-fit items-center justify-end gap-1',
        submitButtonSlot: 'self-end',
        dictationButtonSlot: 'text-penny-13 mt-1'
    },
    variants: {
        colorVariant: {
            default: {
                wrapperSlot: [
                    'border-primary-6 hover:border-primary-10'
                ]
            },
            glass: {
                wrapperSlot: [
                    'bg-glass shadow-penny-md hover:bg-penny-1 focus-within:bg-penny-1 border-transparent backdrop-blur-sm'
                ]
            }
        },
        containerSize: {
            sm: {
                voiceButtonSlot: 'text-icon-18 h-6 w-6'
            },
            md: {
                voiceButtonSlot: 'text-icon-16 h-5 w-5'
            }
        },
        isMultiLine: {
            true: {
                wrapperSlot: 'pb-4 pt-6',
                contentSlot: 'flex-col',
                footerSlot: 'w-full'
            }
        },
        disabled: {
            true: {
                textareaSlot: 'cursor-not-allowed'
            }
        }
    },
    defaultVariants: {
        colorVariant: 'default',
        isMultiLine: false,
        disabled: false
    }
});
export { expandableInputVariants };
